import PropTypes from "prop-types";
import IconArrow from "../../../public/images/arrow-down-mini.svg";
import useEditorPanelButtonStore from "../../../store/useEditorPanelButtonStore";
import {useOutsideClick} from "../../../hooks/useOutsideClick";
import {useRef} from "react";

const Select = ({tab, buttonContent, children}) => {
  const store = useEditorPanelButtonStore();
  const selectRef = useRef(null);
  useOutsideClick(selectRef, {
    onExternalClick: () => {
      if(store.isOpenModal === tab)
      {
        store.setIsOpenModal("");
      }
    },
  });

  return (
    <div className="select__block" ref={selectRef}>
      <button className="select" onClick={() => {
        store.setIsOpenModal(store.isOpenModal === tab ? "" : tab);
      }}>
        {buttonContent}
        <IconArrow className={`select__icon-arrow ${store.isOpenModal !== tab ? "" : "select__icon-arrow-active"}`}/>
      </button>
      {children}
    </div>
  );
};

Select.propTypes = {
  tab: PropTypes.string.isRequired,
  buttonContent: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default Select;
